export default {"src":"/_next/static/media/tune-active.8819064d.svg","height":24,"width":24};